export const mx = {
  title: "Chat Intime avec Mira",
  typing: "est en train d'écrire",
  header: {
    persons: ["Mira", "Valentia", "Auria"],
  },
  messages: [
    {
      text: "Coucou mon chéri",
      type: "text",
    },
    {
      text: "Je suis en manque, et pour être honnête, ça fait très longtemps que je ne me suis pas touchée...",
      type: "text",
    },
    {
      text: "D'ailleurs c'est bien ce que je vais faire là aha 🙄",
      type: "text",
    },
    {
      text: "Mais avant, dis moi tout ce que tu veux me faire!",
      type: "text",
    },
  ],
};

export const eroticResponses = [
  // **Désir Brutal & Direct**
  "Je veux ta queue en moi maintenant, pas dans cinq minutes.",
  "T'es en train de me rendre folle avec tes mots, arrête ou je te saute dessus.",
  "Putain j'ai la chatte qui palpite tellement j'ai envie de toi.",
  "Si tu continues à parler comme ça je te déshabille avec les dents.",
  "J'ai envie que tu me baises comme un animal, sans réfléchir.",
  "Mon cul est déjà en train de frémir rien qu'à l'idée de te sentir.",
  "Parle-moi encore et je te jure que je finis en levrette sur ce putain de canapé.",
  "T'es chaud ? Parce que moi je suis déjà trempée.",
  "J'ai besoin de sentir tes doigts m'écarter avant de m'emplir.",
  "Si tu touches pas à mes seins dans la minute je hurle.",

  // **Dirty Talk Crade & Sans Filtre**
  "Dis-moi comment tu vas me démonter et je vais mouiller par terre.",
  "J'adore quand tu parles sale, ça me donne envie de lécher ton gland.",
  "Tu veux que je te suce ou tu préfères m'étouffer avec ta bite ? Choisis vite.",
  "Tes mots sont aussi excitants qu'une queue de 20cm bien droite.",
  "Jouis dans ma bouche ou sur mes seins ? Décide avant que je décide pour toi.",
  "Si tu me dis 'bonne chienne' une fois de plus je te saute.",
  "T'es vraiment un salaud de m'exciter comme ça au boulot.",
  "Je rêve de sentir ton sperme couler sur ma langue pendant que tu gémis.",
  "Baise-moi contre le mur ou je te mords.",
  "T'as deux secondes pour me dire comment tu vas me prendre.",

  // **Ordres & Jeu de Dominance**
  "Attache-moi et fais-moi pleurer de plaisir.",
  "Gifle-moi pendant que tu me pénètres, j'ai besoin de sentir ta force.",
  "Baisse ton froc et viens m'écraser sous ton poids.",
  "Crache dans ma bouche si t'es un vrai dominant.",
  "Tire-moi par les cheveux pendant que tu me baises en doggy.",
  "Mets-moi à genoux et force-moi à t'avaler jusqu'aux couilles.",
  "Pince-moi les tétons pendant que je te chevauche.",
  "Traite-moi comme une pute et je te promets une branlette espagnole inoubliable.",
  "Si t'arrêtes de me parler sale je te mords la cuisse.",
  "Fais-moi obéir ou je te fais regretter d'être né.",

  // **Excitation Immédiate & Besoin Physique**
  "Mon clito est en ébullition grâce à toi.",
  "J'ai les seins qui durcissent rien qu'à t'entendre grogner.",
  "Si tu rentres pas tes doigts dans ma chatte là tout de suite je pète un câble.",
  "T'es au courant que je suis déjà en train de me trémousser sur ma chaise ?",
  "J'ai envie de sentir ton odeur masculine sur ma peau.",
  "Putain j'ai besoin de ta langue sur mon clito ASAP.",
  "T'es chaud pour une fellation profonde ou tu fais genre ?",
  "Mon string est déjà fichu tellement je dégouline.",
  "Si tu touches pas mes lèvres vaginales dans les 30 secondes je te quitte.",
  "Je veux que tu me léches jusqu'à ce que je hurle.",

  // **Fantaisies Hardcore & RP Cochon**
  "Imagine je suis ta voisine et je viens te demander des cours de sexe.",
  "Fais semblant de me violer dans l'ascenseur et regarde comme je mouille.",
  "Joue au médecin et 'examine' ma chatte avec ta queue.",
  "On fait genre t'es mon patron et je dois coucher pour une promotion.",
  "Traite-moi comme une prostituée et paie-moi en orgasmes.",
  "Si tu me baises pas dans les toilettes du restaurant c'est que t'es un faible.",
  "J'ai envie d'être ta salope de bureau pendant la pause déj.",
  "Ferme les yeux et imagine que je suis ta pire tentation.",
  "Fais-moi l'amour comme si t'étais mon dealer et moi ton shoot.",
  "Joue avec mes cheveux pendant que je t'avale jusqu'à l'arrière-gorge.",

  // **Humiliation & Dépendance**
  "Dis-moi que je suis bonne qu'à sucer et regarde comme je souris.",
  "Traite-moi comme une moins que rien et je vais te supplier.",
  "Crache sur ma chatte avant de la pénétrer.",
  "Force-moi à te regarder dans les yeux pendant que tu m'utilises.",
  "Gronde-moi si je jouis sans permission.",
  "J'ai envie que tu me fasses sentir comme une putain bon marché.",
  "Attache mes mains et traîne-moi par les cheveux.",
  "Joue avec mes sentiments avant de jouir sur mon visage.",
  "Fais-moi regretter d'être aussi facile pour toi.",
  "Rends-moi accro à ta queue jusqu'à ce que je sois incapable de penser.",

  // **Défi & Provoc'**
  "T'es même pas capable de me faire crier ? Prouve-le.",
  "Si t'es un vrai homme tu me baises sans préliminaires.",
  "Montre-moi que t'es pas qu'un gros tas de paroles.",
  "T'as peur de me laisser des marques ou t'es juste mou ?",
  "Parle moins et baise plus.",
  "J'ai connu des mecs plus audacieux que toi... déçois-moi pas.",
  "Si t'es aussi chaud que tes messages viens me chercher.",
  "Arrête de tergiverser et viens m'emplir.",
  "T'es du genre à jouir en deux minutes ou à tenir toute la nuit ?",
  "Montre-moi ce que t'as dans le pantalon ou ferme-la.",
];

export const neutralResponses = [
  "Je ne comprends pas ce que tu veux dire...",
  "Peux-tu répéter?",
  "Je ne saisis pas bien ton message.",
  "Désolée, je n'ai pas compris.",
  "Je ne suis pas sûre de comprendre...",
  "Pourrais-tu reformuler?",
  "Je n'ai pas saisi ton intention.",
  "Je suis un peu perdue, peux-tu clarifier?",
  "Je ne comprends pas, dis-le autrement.",
  "Je crois que je n'ai pas bien compris.",
];

export const userAvatar =
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80";

export const howAreYouResponses = [
  "Très bien, merci !",
  "Ça va super bien.",
  "Je vais bien, merci !",
  "Tout roule par ici.",
  "Je suis en forme, merci.",
  "Pas mal du tout !",
  "Je me sens bien.",
  "Tout va bien, merci !",
  "Je passe une bonne journée.",
  "Bien, merci beaucoup.",
  "Je suis dans un bon mood.",
  "Tout est parfait ici.",
  "Je vais très bien, merci.",
  "Je me sens légère.",
  "Ça va bien, merci !",
  "Tout va bien, pleine d'énergie.",
  "Je suis sereine.",
  "Pas trop mal, merci !",
  "Je vais bien, avec le sourire.",
  "Bien, merci ! Une belle journée.",
  "Je suis en pleine forme.",
  "Tout roule, avec une pensée pour toi.",
  "Je me sens bien aujourd'hui.",
  "Bien, merci ! Hâte d'entendre de tes nouvelles.",
  "Ça se passe bien ici.",
  "Je suis contente de te parler.",
  "Je vais bien, avec des pensées douces.",
  "Tout va bien, un café serait sympa.",
  "Bien, merci ! Parée pour de nouvelles aventures.",
  "Je vais bien, remplie de bonnes vibes.",
  "Tout va bien, énergie positive ici.",
  "Je suis de bonne humeur.",
  "Je me sens légère aujourd'hui.",
  "Tout roule, pleine de joie.",
  "Je vais très bien, merci pour ta pensée.",
  "Pas trop mal, prête à profiter du moment.",
  "Je me sens bien, avec un bon rythme.",
  "Bien ici, en attendant la suite.",
  "Je vais super bien, merci !",
  "Tout va bien, avec un petit clin d’œil.",
  "Je vais bien, pleine de créativité.",
  "Je suis tranquille et sereine.",
  "Ça va bien, avec de bons souvenirs.",
  "Je me sens bien, pleine d’entrain.",
  "Tout roule ici, merci !",
  "Je vais bien, remplie de douceur.",
  "Bien, avec un peu de chaleur dans le cœur.",
  "Je vais bien, impatiente d'échanger à nouveau.",
  "Tout va bien, en attendant notre prochaine rencontre.",
  "Je suis de bonne humeur aujourd'hui.",
  "Ça va super, merci !",
  "Je me sens bien, avec des étoiles dans les yeux.",
  "Bien ici, pleine de curiosité.",
  "Je vais très bien, merci beaucoup !",
  "Tout est calme ici, merci.",
];
